export class Helpers {
  static uuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
      .replace(/[xy]/g, (c) => {
        // tslint:disable-next-line:no-bitwise
        const r = Math.random() * 16 | 0;
        // tslint:disable-next-line:no-bitwise
        const v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
  }

  static async wait(seconds: number) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(true);
      }, seconds * 1000);
    });
  }
  static debounce<T extends Function>(cb: T, wait = 20) {
    let h: any = 0;
    let callable = (...args: any) => {
      clearTimeout(h);
      h = setTimeout(() => cb(...args), wait);
    };
    return <T>(<any>callable);
  }

  static getClaim(key: Claim) {
    try {
      const current_account = localStorage.getItem('current_account');
      if (current_account) {
        const token = JSON.parse(current_account)?.token;
        const res = token ? JSON.parse(atob(token.split(".")[1])) : "";
        return res[key];
      }
    } catch {
      return null
    }

  }
  static arraysEqual(a:any[], b:any[]) {
    if(a.length != b.length) return false;
    return JSON.stringify(a) === JSON.stringify(b);
  }

  static getMime(ext: string) {
    return mime[ext] ?? "application/octet-stream";
  };
  static downloadURL (data: any, filename: string) {
    let a: any;
    a = document.createElement('a');
    a.href = data;
    a.download = filename;
    document.body.appendChild(a);
    a.style = 'display: none';
    a.click();
    a.remove();
  };
  static downloadData (data: Uint8Array, filename: string, ext: string) {


    // tslint:disable-next-line:one-variable-per-declaration
    let blob: any, url: string;

    blob = new Blob([data], {
      type: this.getMime(ext)
    });

    url = window.URL.createObjectURL(blob);

    this.downloadURL(url, filename);

    setTimeout(() => {
      return window.URL.revokeObjectURL(url);
    }, 1000);

  };
}


export interface OnChangePayload {
  type: TypeEnum;
  id?: string;
  payload: any;
}

export enum TypeEnum {
  DateFilter = "date-filter",
  DropDown = "dropdown-filter",
  Toggle = "toggle",
}

export enum Claim {
  Actor = "actort",
  ID = "nameid",
  Name = "unique_name",
  Role = "role",
  Expire = "exp",
}

export enum Role {
  Alpha = "Alpha",
  Manager = "Manager",
  Clerk = "Clerk",
  Supplier = "Supplier",
  Bookmarked = "Bookmarked",
  Importer = "Importer",
  Trucker = "Trucker",
}
export const TextToClipboard = (text: string) => {
  // Create a new clipboard object
  const clipboard = navigator.clipboard;
  // Write the text to the clipboard
  clipboard.writeText(text)
    .then(() => {
      // console.log('Text copied to clipboard');
    })
    .catch((error) => {
      console.error('Failed to copy text: ', error);
    });
};
export const mime: any = {
  html: "text/html",
  htm: "text/html",
  shtml: "text/html",
  css: "text/css",
  xml: "text/xml",
  gif: "image/gif",
  jpeg: "image/jpeg",
  jpg: "image/jpeg",
  js: "application/x-javascript",
  atom: "application/atom+xml",
  rss: "application/rss+xml",
  mml: "text/mathml",
  txt: "text/plain",
  jad: "text/vnd.sun.j2me.app-descriptor",
  wml: "text/vnd.wap.wml",
  htc: "text/x-component",
  png: "image/png",
  tiff: "image/tiff",
  tif: "image/tiff",
  wbmp: "image/vnd.wap.wbmp",
  ico: "image/x-icon",
  jng: "image/x-jng",
  bmp: "image/x-ms-bmp",
  svg: "image/svg+xml",
  webp: "image/webp",
  jar: "application/java-archive",
  war: "application/java-archive",
  ear: "application/java-archive",
  hqx: "application/mac-binhex40",
  doc: "application/msword",
  pdf: "application/pdf",
  ps: "application/postscript",
  eps: "application/postscript",
  ai: "application/postscript",
  rtf: "application/rtf",
  xls: "application/vnd.ms-excel",
  ppt: "application/vnd.ms-powerpoint",
  wmlc: "application/vnd.wap.wmlc",
  kml: "application/vnd.google-earth.kml+xml",
  kmz: "application/vnd.google-earth.kmz",
  "7z": "application/x-7z-compressed",
  cco: "application/x-cocoa",
  jardiff: "application/x-java-archive-diff",
  jnlp: "application/x-java-jnlp-file",
  run: "application/x-makeself",
  pl: "application/x-perl",
  pm: "application/x-perl",
  prc: "application/x-pilot",
  pdb: "application/x-pilot",
  rar: "application/x-rar-compressed",
  rpm: "application/x-redhat-package-manager",
  sea: "application/x-sea",
  swf: "application/x-shockwave-flash",
  sit: "application/x-stuffit",
  tcl: "application/x-tcl",
  tk: "application/x-tcl",
  der: "application/x-x509-ca-cert",
  pem: "application/x-x509-ca-cert",
  crt: "application/x-x509-ca-cert",
  xpi: "application/x-xpinstall",
  xhtml: "application/xhtml+xml",
  zip: "application/zip",
  bin: "application/octet-stream",
  exe: "application/octet-stream",
  dll: "application/octet-stream",
  deb: "application/octet-stream",
  dmg: "application/octet-stream",
  eot: "application/octet-stream",
  iso: "application/octet-stream",
  img: "application/octet-stream",
  msi: "application/octet-stream",
  msp: "application/octet-stream",
  msm: "application/octet-stream",
  mid: "audio/midi",
  midi: "audio/midi",
  kar: "audio/midi",
  mp3: "audio/mpeg",
  ogg: "audio/ogg",
  ra: "audio/x-realaudio",
  "3gpp": "video/3gpp",
  "3gp": "video/3gpp",
  mpeg: "video/mpeg",
  mpg: "video/mpeg",
  mov: "video/quicktime"
};
